import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "col-md-12 mr-auto ml-auto" }
const _hoisted_2 = { class: "wizard-container" }
const _hoisted_3 = {
  class: "card card-wizard active",
  "data-color": "primary"
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-3 mb-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-3 mb-3" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-10 mb-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "col-10 mb-3" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "col-10 mb-3" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "col-10 mb-3" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-10 mb-3" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-10 mb-3" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "col-10 mb-3" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "col-10 mb-3" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-3 mb-3" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "col-3 mb-3" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "col-3 mb-3" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "col-12 mb-3" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "d-flex gap-3 pt-2" }
const _hoisted_39 = { class: "form-check" }
const _hoisted_40 = { class: "form-check" }
const _hoisted_41 = {
  key: 0,
  class: "col-10 mb-3"
}
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = {
  key: 1,
  class: "col-10 mb-3"
}
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { class: "col-12 mt-3" }
const _hoisted_46 = { class: "card" }
const _hoisted_47 = { class: "card-body" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-3 mb-3" }
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = { class: "col-3 mb-3" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-3 mb-3" }
const _hoisted_55 = { class: "form-check mt-4" }
const _hoisted_56 = {
  key: 0,
  class: "col-3 mb-3"
}
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = {
  key: 1,
  class: "col-10 mb-3"
}
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = {
  key: 2,
  class: "col-10 mb-3"
}
const _hoisted_61 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarraBotoes = _resolveComponent("BarraBotoes")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DropDownListTipoBem = _resolveComponent("DropDownListTipoBem")!
  const _component_DropDownListPatFormaTombamento = _resolveComponent("DropDownListPatFormaTombamento")!
  const _component_DropDownListPatEstadoConservacao = _resolveComponent("DropDownListPatEstadoConservacao")!
  const _component_AccordionSection = _resolveComponent("AccordionSection")!
  const _component_DropDownListSala = _resolveComponent("DropDownListSala")!
  const _component_DropDownListFornecedor = _resolveComponent("DropDownListFornecedor")!
  const _component_DropDownListPatMotivoBaixa = _resolveComponent("DropDownListPatMotivoBaixa")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createBlock(_component_BarraBotoes, {
                  loadingSave: _ctx.loadingSave,
                  idRegistroCarregado: _ctx.$route.params.id,
                  key: _ctx.keyRV,
                  gridViewLink: '/patrimonio/patbem',
                  onLimpar: _ctx.limparFormulario,
                  onExcluir: _ctx.excluir
                }, null, 8, ["loadingSave", "idRegistroCarregado", "onLimpar", "onExcluir"])),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_AccordionSection, {
                    title: "Identificação",
                    defaultOpen: true,
                    targetId: "collapseIdentificacao",
                    iconClass: "bi bi-person-badge"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _cache[24] || (_cache[24] = _createElementVNode("label", null, "Código", -1)),
                            _createVNode(_component_Field, {
                              name: "codigo",
                              class: "form-control",
                              type: "text",
                              modelValue: _ctx.model.codigo,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.codigo) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "codigo" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _cache[25] || (_cache[25] = _createElementVNode("label", null, "Quantidade", -1)),
                            _createVNode(_component_Field, {
                              name: "quantidade",
                              class: "form-control",
                              type: "text",
                              modelValue: _ctx.model.quantidade,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.quantidade) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "quantidade" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _cache[26] || (_cache[26] = _createElementVNode("label", null, "Descrição", -1)),
                            _createVNode(_component_Field, {
                              name: "descricao",
                              class: "form-control",
                              type: "text",
                              modelValue: _ctx.model.descricao,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.descricao) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "descricao" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[27] || (_cache[27] = _createElementVNode("label", null, "Observação", -1)),
                            _createVNode(_component_Field, {
                              name: "observacao",
                              as: "textarea",
                              class: "form-control",
                              rows: "4",
                              modelValue: _ctx.model.observacao,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.observacao) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "observacao" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            (_openBlock(), _createBlock(_component_DropDownListTipoBem, {
                              key: `tipo-bem-${_ctx.formKey}-${_ctx.model.patTipoBemId ?? 'novo'}`,
                              modelValue: _ctx.model.patTipoBemId,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.patTipoBemId) = $event))
                            }, null, 8, ["modelValue"])),
                            _createVNode(_component_ErrorMessage, { name: "patTipoBemId" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(), _createBlock(_component_DropDownListPatFormaTombamento, {
                              key: `forma-tombamento-${_ctx.formKey}-${_ctx.model.patFormaTombamentoId ?? 'novo'}`,
                              modelValue: _ctx.model.patFormaTombamentoId,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.patFormaTombamentoId) = $event))
                            }, null, 8, ["modelValue"])),
                            _createVNode(_component_ErrorMessage, { name: "patFormaTombamentoId" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(), _createBlock(_component_DropDownListPatEstadoConservacao, {
                              key: `estado-conservacao-${_ctx.formKey}-${_ctx.model.patEstadoConservacaoId ?? 'novo'}`,
                              modelValue: _ctx.model.patEstadoConservacaoId,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.patEstadoConservacaoId) = $event))
                            }, null, 8, ["modelValue"])),
                            _createVNode(_component_ErrorMessage, { name: "patEstadoConservacaoId" })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AccordionSection, {
                    title: "Localização",
                    defaultOpen: false,
                    targetId: "collapsePublicacao",
                    iconClass: "bi bi-person-badge"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            (_openBlock(), _createBlock(_component_DropDownListSala, {
                              key: `sala-${_ctx.formKey}-${_ctx.model.gesSalaId ?? 'novo'}`,
                              modelValue: _ctx.model.gesSalaId,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.gesSalaId) = $event))
                            }, null, 8, ["modelValue"])),
                            _createVNode(_component_ErrorMessage, { name: "gesSalaId" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _cache[28] || (_cache[28] = _createElementVNode("label", null, "Localização", -1)),
                            _createVNode(_component_Field, {
                              name: "localizacao",
                              class: "form-control",
                              type: "text",
                              modelValue: _ctx.model.localizacao,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.localizacao) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "localizacao" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _cache[29] || (_cache[29] = _createElementVNode("label", null, "Unidade de Guarda", -1)),
                            _createVNode(_component_Field, {
                              name: "unidadeGuarda",
                              class: "form-control",
                              type: "text",
                              modelValue: _ctx.model.unidadeGuarda,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.unidadeGuarda) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "unidadeGuarda" })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AccordionSection, {
                    title: "Aquisição",
                    defaultOpen: false,
                    targetId: "collapseAquisicao",
                    iconClass: "bi bi-person-badge"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _cache[30] || (_cache[30] = _createElementVNode("label", null, "Data de Aquisição", -1)),
                            _createVNode(_component_Field, {
                              name: "dataAquisicao",
                              class: "form-control",
                              type: "date",
                              modelValue: _ctx.model.dataAquisicao,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.dataAquisicao) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "dataAquisicao" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _cache[31] || (_cache[31] = _createElementVNode("label", null, "Valor Aquisição", -1)),
                            _createVNode(_component_Field, {
                              name: "valorAquisicao",
                              class: "form-control",
                              type: "text",
                              modelValue: _ctx.model.valorAquisicao,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.valorAquisicao) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "valorAquisicao" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _cache[32] || (_cache[32] = _createElementVNode("label", null, "Nota Fiscal", -1)),
                            _createVNode(_component_Field, {
                              name: "notaFiscal",
                              class: "form-control",
                              type: "text",
                              modelValue: _ctx.model.notaFiscal,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.notaFiscal) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, { name: "notaFiscal" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _cache[35] || (_cache[35] = _createElementVNode("label", null, "Forma de Aquisição", -1)),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "formaAquisicaoCompra",
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.formaAquisicao) = $event)),
                                  class: "form-check-input",
                                  type: "radio",
                                  name: "formaAquisicao",
                                  value: 0
                                }, null, 512), [
                                  [_vModelRadio, _ctx.model.formaAquisicao]
                                ]),
                                _cache[33] || (_cache[33] = _createElementVNode("label", {
                                  for: "formaAquisicaoCompra",
                                  class: "form-check-label"
                                }, "Compra", -1))
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "formaAquisicaoDoacao",
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.formaAquisicao) = $event)),
                                  class: "form-check-input",
                                  type: "radio",
                                  name: "formaAquisicao",
                                  value: 1
                                }, null, 512), [
                                  [_vModelRadio, _ctx.model.formaAquisicao]
                                ]),
                                _cache[34] || (_cache[34] = _createElementVNode("label", {
                                  for: "formaAquisicaoDoacao",
                                  class: "form-check-label"
                                }, "Doação", -1))
                              ])
                            ]),
                            _createVNode(_component_ErrorMessage, { name: "formaAquisicao" })
                          ])
                        ]),
                        (Number(_ctx.model.formaAquisicao) === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _cache[36] || (_cache[36] = _createElementVNode("label", null, "Termo de Doação", -1)),
                                _createVNode(_component_Field, {
                                  name: "termoDoacao",
                                  class: "form-control",
                                  type: "text",
                                  modelValue: _ctx.model.termoDoacao,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.model.termoDoacao) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, { name: "termoDoacao" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (Number(_ctx.model.formaAquisicao) === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_DropDownListFornecedor, {
                                  modelValue: _ctx.model.gesFornecedorId,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.gesFornecedorId) = $event)),
                                  tipoFornecedor: 1
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, { name: "gesFornecedorId" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "card-header" }, [
                              _createElementVNode("h5", { class: "mb-0" }, "Depreciação")
                            ], -1)),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _cache[37] || (_cache[37] = _createElementVNode("label", null, "Vida Útil", -1)),
                                    _createVNode(_component_Field, {
                                      name: "vidaUtil",
                                      class: "form-control",
                                      type: "text",
                                      modelValue: _ctx.model.vidaUtil,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model.vidaUtil) = $event))
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, { name: "vidaUtil" })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _cache[38] || (_cache[38] = _createElementVNode("label", null, "Valor Residual", -1)),
                                    _createVNode(_component_Field, {
                                      name: "valorResidual",
                                      class: "form-control",
                                      type: "text",
                                      modelValue: _ctx.model.valorResidual,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.valorResidual) = $event))
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, { name: "valorResidual" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AccordionSection, {
                    title: "Baixa",
                    defaultOpen: false,
                    targetId: "collapseBaixa",
                    iconClass: "bi bi-person-badge"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _withDirectives(_createElementVNode("input", {
                              id: "situacao",
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.model.situacao) = $event)),
                              class: "form-check-input",
                              type: "checkbox",
                              "true-value": 1,
                              "false-value": 0,
                              onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onChangeSituacao && _ctx.onChangeSituacao(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.model.situacao]
                            ]),
                            _cache[40] || (_cache[40] = _createElementVNode("label", {
                              for: "situacao",
                              class: "form-check-label"
                            }, "Baixado", -1))
                          ]),
                          _createVNode(_component_ErrorMessage, { name: "situacao" })
                        ]),
                        (Number(_ctx.model.situacao) === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _cache[41] || (_cache[41] = _createElementVNode("label", null, "Data Baixa", -1)),
                                _createVNode(_component_Field, {
                                  name: "dataBaixa",
                                  class: "form-control",
                                  type: "date",
                                  modelValue: _ctx.model.dataBaixa,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.model.dataBaixa) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, { name: "dataBaixa" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (Number(_ctx.model.situacao) === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                (_openBlock(), _createBlock(_component_DropDownListPatMotivoBaixa, {
                                  key: `motivo-baixa-${_ctx.formKey}-${_ctx.model.patMotivoBaixaId ?? 'novo'}`,
                                  modelValue: _ctx.model.patMotivoBaixaId,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.model.patMotivoBaixaId) = $event))
                                }, null, 8, ["modelValue"])),
                                _createVNode(_component_ErrorMessage, { name: "patMotivoBaixaId" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (Number(_ctx.model.situacao) === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _cache[42] || (_cache[42] = _createElementVNode("label", null, "Observação da Baixa", -1)),
                                _createVNode(_component_Field, {
                                  name: "motivoBaixa",
                                  as: "textarea",
                                  class: "form-control",
                                  rows: "4",
                                  modelValue: _ctx.model.motivoBaixa,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.model.motivoBaixa) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, { name: "motivoBaixa" })
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}